// src/App.tsx
import React from 'react';
import Chat from './components/Chat';

const App: React.FC = () => {
  return (
    <div className="App">
      <main>
        <Chat />
      </main>
    </div>
  );
};

export default App;